module.exports = __webpack_public_path__ + "static/media/mode-25.0ddd805c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-25.svg
// module id = 980
// module chunks = 2